// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var listeners = {
  contents: []
};

function addListener(listener) {
  listeners.contents.push(listener);
  return function () {
    listeners.contents = listeners.contents.filter(function (l) {
          return l !== listener;
        });
  };
}

function didLogin() {
  listeners.contents.forEach(function (listener) {
        listener();
      });
}

exports.addListener = addListener;
exports.didLogin = didLogin;
/* No side effect */
